import React from 'react'
import Navbar from '../inc/Navbar'
import {Link}  from "react-router-dom";

function PrincipalSpeech() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <div className='colorgallery'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Principal Massage</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <br/>
<div className="album py-2">
                    <div className="container">
                    <p className="card-text mb-3"> Welcome to Maa Tara Foundation – a beacon of skill, service, and success.</p>
                    <p className="card-text justify mt-1 mb-1"> At Maa Tara Foundation,  It is about empowering individuals with the knowledge, skills, and confidence to shape their future. Our institution is built upon the values of dedication, discipline, and development, and we strive to ensure that every student who walks through our doors becomes a capable, responsible, and compassionate professional.</p>
                    <p className='card-text justify' >hether you are pursuing a career in Industrial Training (ITI), Hotel Management, or the Paramedical sciences, our goal is to provide an education that combines theoretical knowledge with practical application. Our experienced faculty, modern infrastructure, and hands-on training programs ensure that students are industry-ready from day one.

The demand for skilled professionals is growing across the globe, and at Maa Tara Foundation, we are committed to bridging the gap between talent and opportunity. Through partnerships with industry leaders, career-focused training, and value-based education, we prepare our students not just for jobs, but for lifelong careers.</p>

<br/>
<h6 className='mb-0'>With best wishes,</h6>
<h5>[Your Name]</h5>
<p><b>Principal, </b>Maa Tara Foundation</p>
                        </div>
                    </div>

    </div>
  )
}

export default PrincipalSpeech